import { WSCard, WSInfoBox } from "@wingspanhq/fe-component-library";
import { useHistory } from "react-router-dom";

import { useHistoryCheckpoint } from "../../../../../shared/hooks/useHistoryCheckpoint";
import { getBenefitsEnrollInsuranceFlowPathname } from "../../../../Benefits/paths";
import { selectorPlanNameByPlanType } from "../../../../MyResources/selectors/selectorPlanNameByPlanType";

// The Benefits module owns the plan-type contract and both call sites below
// are typed by it, so the type is read off that boundary rather than by
// reaching into the benefits wire spec from a Requirements component.
type IPlanType = Parameters<typeof selectorPlanNameByPlanType>[0];

type Props = {
  // wire value of the coverage/policy type (v3 exposes it as a bare string)
  policyType: string;
};

export const ENROLL_INSURANCE_FROM_REQUIREMENT_CHECKPOINT =
  "ENROLL_INSURANCE_FROM_REQUIREMENT_CHECKPOINT";

export const CardWingspanInsurance: React.FC<Props> = ({ policyType }) => {
  const history = useHistory();
  const historyCheckpoint = useHistoryCheckpoint(
    ENROLL_INSURANCE_FROM_REQUIREMENT_CHECKPOINT
  );

  const planType: IPlanType = [
    "GeneralLiability",
    "ProfessionalLiability"
  ].includes(policyType)
    ? "WingspanProfessionalLiabilityAndGeneralLiabilityInsurance"
    : "WingspanOccupationalAccidentInsurance";

  const insuranceName = selectorPlanNameByPlanType(planType);

  return (
    <WSCard
      actions={{
        alignment: "fill",
        buttons: [
          {
            label: "Enroll now",
            onClick: () => {
              historyCheckpoint.saveCheckpoint();

              history.push(getBenefitsEnrollInsuranceFlowPathname(planType), {
                backPath: history.location.pathname
              });
            }
          }
        ]
      }}
      header={{
        label: {
          avatar: {
            type: "icon",
            icon: "shield-check-fill",
            colorBackground: "garnet"
          },
          text: `${insuranceName}`
        }
      }}
    >
      <WSInfoBox>
        This requirement accepts {insuranceName} - learn more and join thousands
        of contractors in getting instant coverage today and complete the client
        requirement upon successful enrollment.
      </WSInfoBox>
    </WSCard>
  );
};
